import React from 'react';

const KYCItem = ({cls, item}) => (
    <button className={`text-center btn btn--gray my-3 h-50px me-3 ${cls}`}>{item}</button>
);

export default KYCItem;
